import { I18n } from '@calendly/i18n';
import { SimplePopup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetParams } from 'actions/core/navigation';
import { useClearReservedTimesMutation } from 'features/scheduling/data/api';
import { idSelector } from 'selectors/current_user';
const popupDescriptionCss = "p1qwspwg";
const PopupDescription = forwardRef((props, ref) => <BodyText ref={ref} {...props} className={classNames(popupDescriptionCss, props.className)} />);
export const ClearReservedTimesModal = ({
  triggerEventUUID,
  isPoll = false,
  onClose
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentUserId = useSelector(idSelector);
  const [clearReservedTimes] = useClearReservedTimesMutation();
  const dispatch = useDispatch();
  const resetPollsUrl = () => {
    if (!isPoll || onClose) return;
    dispatch(setGetParams({
      trigger_clear_reserved_times: null
    }));
  };
  useEffect(() => {
    if (triggerEventUUID) {
      setIsOpen(true);
    }
  }, [triggerEventUUID]);
  const onConfirm = () => {
    if (triggerEventUUID) {
      clearReservedTimes({
        userId: currentUserId,
        eventTypeId: triggerEventUUID
      });
    }
    resetPollsUrl();
    setIsOpen(false);
  };
  const onCloseModal = () => {
    if (onClose) {
      onClose();
    }
    setIsOpen(false);
    resetPollsUrl();
  };
  if (!triggerEventUUID) return null;
  return <SimplePopup isOpen={isOpen} onClose={() => onCloseModal()} title={I18n.t('publisher.scheduled_events.pending.reserved_times.clear_title')} cancelLabel={I18n.t('publisher.action.cancel')} confirmLabel={I18n.t('publisher.scheduled_events.pending.reserved_times.clear_action')} onConfirm={() => onConfirm()}>
      <PopupDescription>
        {I18n.t('publisher.scheduled_events.pending.reserved_times.clear_description')}
      </PopupDescription>
    </SimplePopup>;
};

require("./clear_reserved_times_modal.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./clear_reserved_times_modal.js");